import React, { useEffect, useState } from 'react';

const ChallengeCompletionModal = ({ isOpen, onClose, rewardStars = 50 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Small delay for animation
      setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

      {/* Modal Content */}
      <div
        className={`relative bg-gradient-to-br from-purple-900/95 via-violet-900/95 to-indigo-900/95 rounded-3xl shadow-2xl border-2 border-purple-400/30 p-8 max-w-md w-full transform transition-all duration-300 ${
          isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Decorative stars in background */}
        <div className="absolute top-4 right-6 w-3 h-3 bg-yellow-300 rounded-full animate-pulse" />
        <div className="absolute top-12 right-12 w-2 h-2 bg-yellow-200 rounded-full animate-pulse delay-150" />
        <div className="absolute top-8 left-8 w-2 h-2 bg-yellow-400 rounded-full animate-pulse delay-300" />

        {/* Content */}
        <div className="text-center space-y-6">
          {/* Title */}
          <h2 className="text-3xl font-bold text-white mb-2">
            Weekly Challenge
            <br />
            Complete! 🎉
          </h2>

          {/* Star Icon - Using a large emoji as placeholder */}
          <div className="flex justify-center my-8">
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-400/30 blur-3xl rounded-full scale-150" />
              {/* Star */}
              <div className="relative text-8xl animate-bounce" style={{ animationDuration: '1.5s' }}>
                ⭐
              </div>
            </div>
          </div>

          {/* Reward Amount */}
          <div className="text-6xl font-bold text-yellow-400 drop-shadow-[0_0_20px_rgba(250,204,21,0.5)]">
            +{rewardStars}
          </div>

          {/* Message */}
          <div className="pt-4 pb-2">
            <p className="text-purple-100 text-lg leading-relaxed">
              Come back next week for the next challenge and to earn more stars!
            </p>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="mt-6 w-full py-3 px-6 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Awesome!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChallengeCompletionModal;
